<div mat-dialog-container class="container">
    <div class="close" (click)="close()">
        <mat-icon>close</mat-icon>
    </div>

    @if (file.contentType.includes("image")) {
        <div class="content">
            <img [src]="filePath + file.filePath" />
        </div>
    }

    @if (file.contentType.includes("video")) {
        <div class="content">
            <video controls>
                <source [src]="filePath + file.filePath" type="video/mp4" />
            </video>
        </div>
    }

    @if (!file.contentType.includes("image") && !file.contentType.includes("video")) {
        <div class="content">
            <h1>{{ file.fileName }}</h1>
            <a [href]="filePath + file.filePath" target="_blank" download>Ver fichero</a>
        </div>
    }
</div>
